import type { PopupPlotState } from "@/reducer/plot/state";

export enum PopupPlotActionType {
  SetPopupPlotState = 1,
}

export interface SetPopupPlotState {
  type: PopupPlotActionType.SetPopupPlotState;
  payload: PopupPlotState;
}

export type PopupPlotsActions = SetPopupPlotState;
